import { BASVURU_TAHAKKUK_OLUSTUR } from "../constants/requestUrls";
import { postRequest } from "../request";

const BasvuruTahakkukOlustur = (props) => {
    let data ={};
    if(props !== undefined)
    data = JSON.stringify(props);
    return postRequest({url:BASVURU_TAHAKKUK_OLUSTUR,data}).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
    });
}

export default BasvuruTahakkukOlustur;